var SCM = SCM || {};

(function (ns, $) {
    var gdprCookieNamePrefix = 'GDPR_';
    var gdprStatsActionKey = '1050';
    var gdprStatsActionValue = '0';
    var gdprStatsActionDescription = 'Cookie Acceptance';
    var customCookieName = '';

    ns.getGdprCookie = function (cookieName) {
        var name = cookieName + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };

    ns.createGdprCookie = function (name, value, days) {
        var cookieName = ns.getCookieName();

        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toGMTString();
        } else {
            expires = '';
        }

        var cookieDefault = cookieName + '=' + encodeURIComponent(value) + expires + '; samesite=lax; secure; path=/';

        var domain = ns.getCookieDomain();
        var gdprCookie = null;

        // set cookie with specified domain
        if (domain) {
            document.cookie = cookieDefault + ';domain=' + domain;
            gdprCookie = ns.getGdprCookie(cookieName);
        }

        // fall back to default domain if it couldn't be specified, e.g. through an Ezproxy URL
        if (!domain || !gdprCookie) {
            document.cookie = cookieDefault;
        }
    };

    ns.getCookieName = function () {
        if (customCookieName) {
            return customCookieName;
        }

        var clientId = $('#hdnClientIdGdpr').val();
        var domain = ns.getCookieDomain();

        var cookieName = gdprCookieNamePrefix;
        if (clientId) {
            cookieName = cookieName + clientId + '_';
        }
        if (domain) {
            cookieName = cookieName + domain;
        }

        return cookieName;
    };

    ns.getCookieDomain = function () {
        return $('#hdnDomainGdpr').val();
    };

    ns.hideGdprBanner = function () {
        var gdprCookieWrapper = $('.js-gdpr-banner');

        if (!navigator.cookieEnabled) {
            gdprCookieWrapper.hide();
            $('body').removeClass('gdpr-visible');
            $('.js-gdpr-banner').addClass('hidden');
            return;
        }

        var cookieName = ns.getCookieName();

        var gdprCookie = ns.getGdprCookie(cookieName);

        if (gdprCookie) {
            gdprCookieWrapper.hide();
            $('body').removeClass('gdpr-visible');
            $('.js-gdpr-banner').addClass('hidden');
        }
        else
        {
            $('.js-gdpr-banner').removeClass('hidden');
            var $banner = $('.js-gdpr-banner');
            var $firstFocusable = $banner.find('a, button, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
            if ($firstFocusable.length) {
                $firstFocusable.focus();
            }
        }
    };

    ns.gdprAcceptLinkClick = function () {
        $('.js-gdpr-cookie-acceptLink, .js-gdpr-cookie-close').on('click', function () {
            ns.createGdprCookie(gdprCookieNamePrefix, true, 365);
            ns.hideGdprBanner();
            if (SCM.ClientStatsMaster && SCM.ClientStatsMaster.trackGdprCookieAcceptance) {
                SCM.ClientStatsMaster.trackGdprCookieAcceptance(gdprStatsActionKey, gdprStatsActionValue, gdprStatsActionDescription);
            }
            $('#skipNav').focus();
            SCM.EventEmitter.publish('viewport-changed');
        });
    };

    ns.init = function (cookieName) {
        if (cookieName) {
            customCookieName = cookieName;
        }
        $('body').addClass('gdpr-visible');
        ns.gdprAcceptLinkClick();
        ns.hideGdprBanner();
    };
})(SCM.gdprCookieBanner = SCM.gdprCookieBanner || {}, jQuery);